/* Top level history page. This page should get all titles from MongoDB and show them. Upon
   clicking on a title, a component should then show that entry. That component should be
   re-used on any page where a history entry needs to be shown. */

import React, { useState }                      from 'react'
import Box                                      from '@material-ui/core/Box'
import Grid                                     from '@material-ui/core/Grid'
import GuestBioDeleteComponent                  from '../Components/GuestBioDeleteComponent.js'
import HistoryCitationDeleteComponent           from '../Components/HistoryCitationDeleteComponent.js'
import HistoryEntryDeleteComponent              from '../Components/HistoryEntryDeleteComponent.js'
import { historyEntryTypeRadioOptions }         from '../config'
import InfoComponent                            from '../Components/InfoComponent.js'
import PilotCohortSourceDeleteComponent         from '../Components/PilotCohortSourceDeleteComponent.js'
import RadioOptionComponent                     from '../Components/RadioOptionComponent.js'
import Typography                               from '@material-ui/core/Typography'

const HistoryDeletePage = () => {

   const [ guestBioEntry,                       setGuestBioEntry                 ]  =  useState(false)
   const [ historyCitation,                     setHistoryCitation               ]  =  useState(false)
   const [ historyEntry,                        setHistoryEntry                  ]  =  useState(false)
   const [ pilotCohortSourceTableEntry,         setPilotCohortSourceTableEntry   ]  =  useState(false)
   const [ showInfoComponent,                   setShowInfoComponent             ]  =  useState(true)

   const info = [
      'Be careful here, clicking on a title will delete that Historical entry from the database.',
      'This action is not reversible.'
   ]

   const closeComponent = () => {
      setShowInfoComponent(false)
   }

   const getOption = (o) => {
      switch (o) {
         case 'Guest Bio Entry':
            setGuestBioEntry(true)
         break
         case 'History Citation':
            setHistoryCitation(true)
         break
         case 'History Entry':
            setHistoryEntry(true)
         break
         case 'Pilot / Cohort / Source Table':
            setPilotCohortSourceTableEntry(true)
         break
      }
      closeComponent()
   }

   return (
      <Box>
         { showInfoComponent ? <InfoComponent closeComponent={closeComponent} info={info} /> : null }
         {guestBioEntry || historyEntry || historyCitation || pilotCohortSourceTableEntry
            ?
               null
            :
               <Grid style={{ marginTop: '6rem' }} >
                  <Typography variant='h4' >
                     Delete Page
                  </Typography>
                  <RadioOptionComponent getOption={getOption} options={historyEntryTypeRadioOptions} />
               </Grid>
         }
         {guestBioEntry                ?  <GuestBioDeleteComponent />            :  null}
         {historyCitation              ?  <HistoryCitationDeleteComponent />     :  null}
         {historyEntry                 ?  <HistoryEntryDeleteComponent />             :  null}
         {pilotCohortSourceTableEntry  ?  <PilotCohortSourceDeleteComponent />   :  null}
      </Box>
   )
}

export default HistoryDeletePage
